import { useMemo } from 'react';
import BigNumber from 'bignumber.js';

import { ZERO } from 'modules/common/const';
import { useGetSortedPools } from 'modules/pool/hooks/useGetSortedPools';

interface IUseGetTotalStakedResult {
  totalStakedAmount: BigNumber;
  totalStakers: BigNumber;
  isLoading: boolean;
}

export function useGetTotalStaked(
  poolsLimit?: number,
): IUseGetTotalStakedResult {
  const { pools, isLoading } = useGetSortedPools();

  const { totalStakedAmount, totalStakers } = useMemo(
    () =>
      (typeof poolsLimit === 'number'
        ? pools.slice(0, poolsLimit)
        : pools
      ).reduce(
        (acc, { tvl, totalDelegators }) => ({
          totalStakedAmount: acc.totalStakedAmount.plus(tvl),
          totalStakers: acc.totalStakers.plus(totalDelegators),
        }),
        { totalStakedAmount: ZERO, totalStakers: ZERO },
      ),
    [pools, poolsLimit],
  );

  return {
    totalStakedAmount,
    totalStakers,
    isLoading,
  };
}
